import { ReceivedInvoiceAiSuggestStatusProperty } from '@/context/services/invoice/type';
import { IconPending } from '@moneyforward/ap-frontend-components';
import cx from 'classnames';
import { FC, memo } from 'react';
import styles from '../columns.module.scss';
import { ProcessingStatusTag } from './components/ProcessingStatusTag';
import { useProcessingStatusTags } from './hooks/useProcessingStatusTags';

const InnerFileNameCell: FC<{
  name: string;
  ext: string | null | undefined;
  aiSuggestStatus?: ReceivedInvoiceAiSuggestStatusProperty;
}> = ({ name, ext, aiSuggestStatus }) => {
  const { statusTagsInfo } = useProcessingStatusTags(aiSuggestStatus);

  // Add icons to the tags
  const tagsWithIcons = statusTagsInfo.map((tag) => ({
    ...tag,
    customIcon: tag.customIcon === null ? <IconPending /> : tag.customIcon,
  }));

  return (
    <>
      <div className={cx(styles['fileNameContainer'])}>
        <div className={cx(styles['fileName'])}>{name}</div>
        {ext && <div className={cx(styles['fileExtension'])}>.{ext}</div>}
      </div>
      <ProcessingStatusTag statusTagsInfo={tagsWithIcons} />
    </>
  );
};

InnerFileNameCell.displayName = 'InnerFileNameCell';

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const FileNameCell = memo((props) => (
  <InnerFileNameCell {...props} />
)) as typeof InnerFileNameCell;
FileNameCell.displayName = 'FileNameCell';
